<template>
  <div>
    <h2 class="text-2xl lg:text-4xl font-bold mb-8 mt-2">
      {{
        userStore.isFptMarket
          ? `${questionCount} câu hỏi cho môn ${categoryTitle}`
          : LL.interview_pro_description({
              count: questionCount,
              name: categoryTitle,
            })
      }}
    </h2>
    <InterviewQuestionFilter />
  </div>
</template>

<script lang="ts" setup>
import { useUserStore } from "../../../store/user";
import { typesafeI18n } from "~/locales/i18n-vue";

const userStore = useUserStore();

defineProps({
  categoryTitle: {
    type: String,
    required: true,
  },
  questionCount: {
    type: Number,
    required: true,
    default: 0,
  },
});

const { LL } = typesafeI18n();
</script>
